import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Operation } from '../_models/operation';

@Injectable({
  providedIn: 'root',
})
export class OperationsService {
  // Get data about operation you need to edit and pass it to edit component
  public updateOperationData = new BehaviorSubject<Operation>(null);

  constructor(private http: HttpClient) {}

  getAllOperations() {
    return this.http
      .get<Operation[]>(`${environment.apiUrl}/api/operations`)
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  getAllNoPagination() {
    return this.http.get<Operation[]>(`${environment.apiUrl}/api/operations`);
  }

  deleteOperation(operationId: number) {
    return this.http.delete(
      `${environment.apiUrl}/api/operations/${operationId}`
    );
  }

  updateOperation(operation: Operation, operationId: number) {
    return this.http.patch<Operation>(
      `${environment.apiUrl}/api/operations/${operationId}`,
      operation
    );
  }

  addOperation(operation: Operation) {
    return this.http.post<Operation>(
      `${environment.apiUrl}/api/operations`,
      operation
    );
  }

  handleError(err) {
    return throwError(err);
  }
}
